import { render, staticRenderFns } from "./StepText.vue?vue&type=template&id=b456e95e&scoped=true&"
import script from "./StepText.vue?vue&type=script&lang=js&"
export * from "./StepText.vue?vue&type=script&lang=js&"
import style0 from "./StepText.vue?vue&type=style&index=0&id=b456e95e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456e95e",
  null
  
)

export default component.exports